import getDoorsFromWallParts from 'components/configurator/services/getDoorsFromWallParts';
import glassWallPartTypes from 'components/configurator/types/glassWallPartTypes';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IGlassWallGlass from 'components/interfaces/IGlassWallGlass';
import IWall from 'components/interfaces/IWall';
import store from 'store/store';
import { isSlidyDoor } from 'components/configurator/types/doorTypes';
import { LEFT, RIGHT } from 'components/configurator/types/doorHangTypes';
import { setWall } from 'store/selectedWall/actions';

import {
  is2kAluGlazy,
  isSlidy30,
  isSlidy36,
} from 'components/configurator/types/glazingWallTypesCheck';

import {
  SE0020,
  SE0026,
  SE0134,
  SE0204,
  SEXXXX20,
} from 'components/configurator/types/verticalProfileTypes';

const updateDependenciesBasedOnFirstDoorLastDoor = (
  wall: IWall | null
): void => {
  if (wall === null) {
    return;
  }
  let wallCopy = { ...wall };
  wallCopy = setProfiles(wallCopy, wall);

  wallCopy.parts = wallCopy.parts.map(
    (part: IGlassWallDoor | IGlassWallGlass) => {
      if (part.type === glassWallPartTypes.glass) {
        return part;
      }

      const door = part as IGlassWallDoor;

      if (!isSlidyDoor(door)) {
        return door;
      }

      let { doorHang } = door;
      if (door.isFirstDoor) {
        doorHang = RIGHT;
      }

      if (door.isLastDoor) {
        doorHang = LEFT;
      }

      return {
        ...door,
        doorHang,
      };
    }
  );

  store.dispatch(setWall(wallCopy));
};

const setProfiles = (wallCopy: any, wall: any) => {
  const doors = getDoorsFromWallParts(wallCopy);
  const hasFirstDoor = doors.length !== 0 && doors[0].isFirstDoor;
  const hasLastDoor = doors.length !== 0 && doors[doors.length - 1].isLastDoor;

  if (is2kAluGlazy(wall)) {
    wallCopy.leftVerticalProfileType = SE0204;
    wallCopy.rightVerticalProfileType = SE0204;
  } else if (isSlidy30(wall)) {
    if (hasFirstDoor) {
      wallCopy.leftVerticalProfileType = SE0020;
    } else if (wallCopy.aluGlazyFloorProfileType === SE0026) {
      wallCopy.leftVerticalProfileType = SE0026;
    } else {
      wallCopy.leftVerticalProfileType = SE0134;
    }

    if (hasLastDoor) {
      wallCopy.rightVerticalProfileType = SE0020;
    } else if (wallCopy.aluGlazyFloorProfileType === SE0026) {
      wallCopy.rightVerticalProfileType = SE0026;
    } else {
      wallCopy.rightVerticalProfileType = SE0134;
    }
  } else if (isSlidy36(wall)) {
    if (hasFirstDoor) {
      wallCopy.leftVerticalProfileType = SEXXXX20;
    } else if (wallCopy.aluGlazyFloorProfileType === SE0026) {
      wallCopy.leftVerticalProfileType = SE0026;
    } else {
      wallCopy.leftVerticalProfileType = SE0134;
    }

    if (hasLastDoor) {
      wallCopy.rightVerticalProfileType = SEXXXX20;
    } else if (wallCopy.aluGlazyFloorProfileType === SE0026) {
      wallCopy.rightVerticalProfileType = SE0026;
    } else {
      wallCopy.rightVerticalProfileType = SE0134;
    }
  }

  if (wall.rightVerticalProfileType === '-') {
    wallCopy.rightVerticalProfileType = '-';
  }
  if (wall.leftVerticalProfileType === '-') {
    wallCopy.leftVerticalProfileType = '-';
  }
  return wallCopy;
};

export default updateDependenciesBasedOnFirstDoorLastDoor;
